import styled from 'styled-components';

export const SocialButton = styled.button`
  width: 42px;
  height: 42px;
  background: transparent;
  border-radius: 50%;
  border: 1px solid #828282;
  display: flex;
  justify-content: center;
  align-items: center;
`;